<template>
    <div>
        <form @submit.prevent="submitBlockList">
            <div class="row">
                <div class="col-sm-12 col-md-6">
                    <div class="form-group">
                    <label class="form-label">{{$t('label.outlet')}}</label>
                        <div class="input-group-prepend w-100">
                            <label class="input-group-text bg-transparent border-top-right-radius-0 border-bottom-right-radius-0 border-right-0">
                                <i class="fas fa-store"></i>
                            </label>
                            <multiselect v-model="selectedOutlet" label="text" track-by="id" :options="outlet" :searchable="false" :show-labels="false" openDirection="below" @select="selectOutlet">
                                <template slot="option" slot-scope="{ option }">{{option.text}}</template>
                            </multiselect>
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="form-label">{{$t('label.contact')}}</label>
                        <div class="input-group bg-white shadow-inset-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text bg-transparent border-right-0">
                                    <i class="fas fa-phone-alt"></i>
                                </span>
                            </div>
                            <input type="text" class="form-control bg-transparent pl-3" :placeholder="$t('label.contact')" v-model="contact" @keyup="contactValidation">
                        </div>
                        <div id="err" class="error-validation"></div>
                    </div>
                </div>
                <div class="border-left col-sm-12 col-md-6 d-flex align-items-center">
                    <div class="help-block fs-md">
                        <p>{{$t('message.contact_validation.notes')}}:</p>
                        <ul>
                            <li>{{$t('message.contact_validation.my')}} 601x xxx xxxx</li>
                            <li>{{$t('message.contact_validation.sg')}} 65x xxx xxxx</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="text-left mt-5">
                <button type="button" class="btn border-0 btn-secondary btn-padding waves-effect waves-themed mr-3" @click="returnBlockList">{{$t('button_link.cancel')}}</button>
                <button type="submit" class="btn border-0 btn-primary btn-padding waves-effect waves-themed">{{$t('button_link.save')}}</button>
            </div>
        </form>
    </div>
</template>
<script>
import {contactValidation} from './../../../../assets/js/dashboard/utilities'
export default {
    name: "bookingBlockListForm",
    data: () => ({
        outlet: [], selectedOutlet: {},
        contact: "",
    }),
    methods:{
        contactValidation(){
            var err = contactValidation(this.contact);
            document.getElementById('err').innerHTML = err == null ? null : this.$i18n.t('message.contact_validation.phone_number', {
                'error':  this.$i18n.t(`message.contact_validation.error.${err}`)
            })
        },
        selectOutlet(item){
            this.selectedOutlet = item;
        },
        returnBlockList(){
            this.$emit('returnBlockList');
        },
        submitBlockList(){
            var data = {
                outletID: this.selectedOutlet.id,
                mobile: this.contact
            }
            this.$emit('submitBlockList', data)
        }
    },
    mounted(){
        let $vm = this;
        $vm.outlet = JSON.parse($vm.$store.state.outlets);
        $vm.selectedOutlet = $vm.outlet[0];
    }
}
</script>
<style scoped>
.error-validation{
    font-size: 0.6875rem;
    margin-top: 0.325rem;
    color: #fd3995;
}
</style>